'use client';

import Image from 'next/image';

export const MaintenanceInfo = () => {
  return (
    <main className="relative flex flex-col gap-y-8 md:gap-y-20 md:pt-20 md:p-20 lg:pl-[180px] lg:pr-[120px] animate-appear p-8">
      <Image
        priority
        fill
        className="object-cover z-[-1]"
        src="/assets/images/maintenance-bg.svg"
        alt="Scheduled Maintenance"
      />
      <p className="bg-black w-fit z-10 font-chakra p-4 md:px-12 md:py-9 rounded-[100px] uppercase text-base sm:text-lg md:text-[2.4vw]">
        Scheduled Maintenance
      </p>
      <p className="font-chakra text-black uppercase text-[32px] sm:text-[50px] md:text-[60px] lg:text-[4.5vw] leading-[92%] z-10">
        Mode Airdrop page under 1-hour maintenance for accurate points update. Your points and assets are secure.
      </p>
      <Image
        priority
        width={1920}
        height={500}
        className="absolute left-0 bottom-0 w-full z-0"
        src="/assets/images/maintenance-mode-logo.svg"
        alt="Mode"
      />
    </main>
  );
};
